export default {
  //首页表头相关的翻译
  layout: {
    header: {
      acccountPoints: "Acccount Points",
      perPoints: "Permanent Points",
      clientDownload:"Client Download",
      //套餐类型
      packageType: "Package",
      //优质
      highQuality: "High Quality",
      // 服务条款
      FWTK: 'Terms of Service',
      // 隐私政策
      YSZC: "Privacy Policy",
      nodata: "No Data",
      noValue: "Nothing"
    },
    account:{
      package:"Package",
      account:"Account",
      exit:"Exit",
    },
    //菜单显示
    menu: {
      //工作空间
      workspace: "Workspace",
      //我的AI
      myAI: "My AI",
      //定制音色
      customizedVoice: "Customized Voice",
      //定制聊天机器人
      customizedChatbot: "Customized Chatbot",
      //限时活动
      limitedTimeActivity: "Limited Time Activity",
      //协作
      cooperation: "Members",
      //团队
      team: "User",
      //账号
      account: "Account",
      //账号中心
      accountCenter: "Account Center",
      //套餐
      package: "Package",
      //账单
      bill: "Bill",
      //点数消耗
      pointsConsumption: "Points Consumption",
    },
  },
  // 团队
  team: {
    teamUse: 'Team Points Used',
    allpoints: "All Points",
    teampeple: "Team Members",
    allpeple: "Total Team Members",
    state: "State",
    action: "Action",
    invite: "Invite",
    describe: "*Invite other users to join your team to share your points and packages, allowing every member of the team to share your advanced features and facilitate team collaboration"
  },
  //兑换码弹窗
  redeemDialog:{
    redeem:"Redeem code",
    title:'Enter Redemption Code',
    typeRedeemPlaceholder:'Please enter the redemption code',
    confirm: "confirm",
    cancel: "cancel",
  },
  //账号中心
  accountcenter: {
    //基本信息
    basicInformation: "BasicInformation",
    //用户名
    userName: "UserName",
    //用户ID
    userID: "UserID",
    //点 数
    points: "Points",
    //套餐内容
    packageContent: "Package Content",
    expireTime: "Expire at",

    //第三方绑定
    thirdPartyBinding: "Linked Account",
    //解绑
    unbundling: "Unlink",
    //修改手机号
    changePhoneNumber: "Change Phone Number Or Email",
    //手机号
    phoneNumber: "Phone Number",
    // 邮箱
    email: "Email",
    //验证码
    verificationCode: "Verification Code",
    //发送短信
    sendSMS: "Send SMS",
    //修改密码
    changePassword: "Change Password",
    //新密码
    newPassword: "New Password",
    //确认密码
    confirmPassword: "Confirm Password",
    //确认修改
    confirmModification: "Confirm Modification",
    // 图形验证码
    picyzm: "Graphic verification code",
  },
  //账单
  bill: {
    //当前计费周期
    currentBillingCycle: "Current Billing Cycle",
    //按月
    monthly: "Monthly",
    //购买时间
    purchaseTime: "Purchase Time",
    //到期时间
    expirationTime: "Expiration Time",
    //订单历史记录
    orderHistory: "Order History",
    //开始时间
    startTime: "Start Time",
    //选择日期
    selectDate: "Select Date",
    //结束时间
    endTime: "End Time",
    //查询
    query: "Query",
    // 计费周期
    billingCycle: "Billing Cycle",
    // 描述
    describe: 'Description',
    //价格
    price: "Amount",
    // 点数消耗
    PointConsumption: "PointConsumption",
    // 点数消耗
    balance: "balance",
    // 信息
    infor: "Infor",
    // 日期
    date: "Date",
  }, //套餐
  package: {
     // 包年
     yearly: "Yearly",
     // 包月
     monthly: "Monthly",
    //充值点数
    topUpPoints: "Top up permanent points",
    //请选择
    pleaseSelect: "Please Select",
    //订阅
    subscribe: "Subscribe",
    // 延期
    delay: "Delay",
    // 升级
    upgrade: "Upgrade",
    // 免费试用
    freeTrial: "FreeTrial",
    //套餐情况
    packageStatus: "Package status",
    paymentMethod: "Payment Method",
    paymentAlipay: "Alipay",
    //已选择的套餐
    theSelectedOffer: "The selected offer",
    //确认
    confirm: "confirm",
    //支付方式
    paymentMethods: "Payment Methods",
    //微信支付
    weChatPay: "WeChat Pay",
    //支付宝支付
    alipayPayment: "Alipay payment",
    //信用卡
    creditCard: "credit card",
    //其它支付方式
    otherPaymentMethods: "Other payment methods",
    //卡号
    cardNumber: "Card number",
    //有效期
    expirationDate: "Expiration date",
    //国家/地区
    countryRegion: "Country/Region",
    //邮编
    zip: "Zip",
    //返回
    cancel: "Cancel",
    contactUs: 'Contact Us',
    firstChargeDouble:'First Charge Double',
    sendPoint:'Send',


  },
  myAi: {
    delete: 'Delete',
    robotStatus: 'Robot status',
    done: 'Done',
    generating: 'Generating',
    abnormal: 'Abnormal',
  },
  custom: {
    videoCustomizationDisplay: 'Video Customization Display',
    customizationInstructions: 'Customization Instructions',
    UploadRecordingInstructions: 'Upload recording Instructions',
    uploadInstructions: 'Upload Instructions',
    clickToAddAudio: 'Click to add audio',
    clickVerificationAudio: 'Click to upload identity verification audio',
    recordingDMandarin: 'RecordingDuration is 10-15 seconds, recorded in Mandarin',
    clickToUploadIdentityVerificationAudio: 'Click to upload identity verification audio',
    recordingMandarin: 'recordingDuration is 10-15 seconds, recorded in Mandarin',
    confirmClearly: 'To confirm your identity, please provide a recording of yourself and read the following text clearly',
    confirmText: 'I confirm that the materials purchased from the customized service and uploaded, including images and sounds, are all my own and I am responsible for creating the content. I promise not to create any illegal content.',
    DZXZTip1: '1.To ensure that the final customization effect is basically consistent with the original audio you uploaded in terms of timbre, style, and rhythm, please ensure that the original audio status you uploaded meets your personal ideal requirements.',
    DZXZTip2: '2.After you submit the order, in order to ensure the high-quality customization effect, we will review the audio you uploaded. If the audio you upload does not meet the customization requirements, you will see an exception in "My AI" and need to upload it again according to our requirements.',
    DZXZTip3: '3.Once approved, the customization process will begin. We expect the entire customization process to be completed within 3 working days. Please be patient and wait.',
    DZXZTip4: '4.After customization is completed, you will receive one year of usage rights for the customized voice. After the expiration of the usage right, you can choose to renew at a price of 299 yuan/year.',
    DZXZTip5: '5.When using a voice pack, you need to consume points to supplement your quota.',
    DZXZTip6: '6.Thank you for choosing our customized service. If you have any questions or need further assistance, please feel free to contact us at any time.',
    SCXZTip1: '1. Please upload a recording of yourself to confirm your identity. Please read out the following text clearly during the recording.',
    SCXZTip2: '2. Reading copy: The materials, images, and sounds uploaded by me when purchasing customized services are my own, and I am responsible for creating content and will not create illegal content.',
    SCXZRTip1: '1. The recording duration is 10-15 seconds, and Mandarin is used for recording.',
    SCXZRTip2: '2. The audio should not contain other languages or dialects, and try to avoid including English words or letters as much as possible',
    SCXZRTip3: '3. The recording should be natural and smooth, with natural pauses and rhythms. When expressing emotions, make sure not to exaggerate excessively.',
    SCXZRTip4: '4. Pronunciation should be clear and accurate, and errors in pronunciation, intonation, and noise should be avoided as much as possible.',
    SCXZRTip5: '5. All recordings must be made by the same person and must not be mixed with the voices of others.',
    SCXZRTip6: '6. To ensure the recording effect, please use a high-performance phone or recording device with microphone function for recording.',
    SCXZRTip7: '7. Please record in a quiet environment using Mandarin, and it is recommended to save the audio file in. wav format at a sampling rate of 48kHz.',
    SCXZRTip8: 'Please ensure that the audio meets the following requirements:',
    cancel: 'Cancel',
    addVoice: 'Add Voice',
    dialogCon: "I hereby confirm that I have all necessary rights or consents to upload and clone these voice samples and that I will not use the platform-generated content for any illegal, fraudulent, or harmful purpose. I reaffirm my obligation to abide by YiSoundaAI’ Terms of Service and Privacy Policy.",
    approval: 'Please Select Approval',

  },
  form: {
    setRobotName: 'Set Robot Name',
    setGender: "Gender",
    man: "Male",
    fell: "Female",
    setlang: "Language",
    zh: "Chinese",
    en: "English",
    basicPrompt: 'Describe',
    describe: "Describe",
    delay: 'Extend',
    upgrade: 'Upgrade',
    freeTrial: 'Free Trial',
    domainName: "Domain Name",
    uploadFile: "Click To Upload The File",
    uploadFile1: "Upload Files",
    uploadWebsite: "Upload Website",
    basicSettings: 'Basic Settings',
    embedDataSettings: 'Embed Data Settings',
    WebsiteEmbeddingSettings: 'Website Embedding Settings',
    ApplicableWhenEmbeddingWebsites: 'Applicable When Embedding Websites',
    reset: 'Reset',
    chatInterface: 'Chat Interface',
    InitiatingMessage: 'Initiating Message',
    stMessage: 'Suggest Leaving A Message',
    theme: 'Theme',
    UpdateChatbotPicture: 'Update Chatbot Profile Picture',
    selectFile: 'Select File',
    DeleteChatbotPicture: 'Delete Chatbot Profile Picture',
    name: 'Name',
    UserMessageColor: 'User Message Color',
    tip: "**If the changes here don't show up immediately on your website try clearing your browser cache or use incognito. (New users will see the changes immediately)**",
    tip1: "Enter each field in the new line",
    tip2: 'The domain you want to embed in the Chatbot. Your Chatbot visibility must be "public" or "private", but can be embedded in the website "to work".',
    enterUrl: 'Enter Url',
    getMoreConnections: 'Get More Connections',
    OtherLinks: 'Other Links',
    createNow: 'Create Now',
    chatinput: "Please enter content",
    chatreply: "Hello, how can I help you? ",
    userreply: "Order me a cup of strawberry milk bobo"
  },

  resetPassword: {
    title: 'Forgot Password',
    toLogin: 'To login',
    toRegistry: "To Register",
    pleaseEnter: 'Please enter the registered phone number so that we will verify and send send you code',
    enterTheCode: 'Enter the code in picture',
    sendCode: 'Send Code',
    passWord: 'Please enter Password',
    passWordZZ:"The password must be at least 8 digits and must be a combination of two or more letters, numbers, and special characters.",
    angpassword: "Please enter the secondary password",
    recommendCode: "(Optional) Please enter the invitation code",
    twopasswordNotSame:"The password entered twice is inconsistent!",
    verify: 'Verify',
    verifyCode: 'Please enter verify code',
    phoneInput: 'Please enter the phone number',
    phoneInputByZZ:"Phone number format is incorrect!",
    mailInput:'please input your email',
    mailInputByZZ:'E-mail format is incorrect!',
    usernameInput: 'Please enter your user name',
    imgVerifyCode: 'Please enter img verify code',
    imgVerifyCodeByZZ:"Wrong graphic verification code format!",
    registry: "Registry",
    login: 'Login',
    forgetpassword: "Forgot password",
    noaccout: "No account",
    loginbyaccout: "Account password",
    loginbyphone: "Verification code to log in",
    otherlogin: "Other Login"
  },
};
